import { render } from "./PhishingReminder.vue?vue&type=template&id=ac09de9a&scoped=true"
import script from "./PhishingReminder.vue?vue&type=script&lang=js"
export * from "./PhishingReminder.vue?vue&type=script&lang=js"

import "./PhishingReminder.vue?vue&type=style&index=0&id=ac09de9a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac09de9a"]])

export default __exports__